import type { CSSProperties } from 'react';

type HeadingVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface ThemePreset {
  readonly spacingScale: number;
  readonly fontFamily: string;
  readonly headingFontFamily: string;
  readonly headings: Record<HeadingVariant, CSSProperties>;
}

export const portalPreset: ThemePreset = {
  spacingScale: 1,
  fontFamily: 'Inter,sans-serif',
  headingFontFamily: 'ModernEra-ExtraBold,sans-serif',
  headings: {
    h1: { fontSize: '2.25rem', lineHeight: '2.75rem' },
    h2: { fontSize: '2rem', lineHeight: '2.5rem' },
    h3: { fontSize: '1.75rem', lineHeight: '2.25rem' },
    h4: { fontSize: '1.5rem', lineHeight: '2rem' },
    h5: { fontSize: '1.25rem', lineHeight: '1.75rem' },
    h6: { fontSize: '1.125rem', lineHeight: '1.625rem' },
  },
};

export const adminPreset: ThemePreset = {
  spacingScale: 0.75,
  fontFamily: "'Inter Tight',sans-serif",
  headingFontFamily: 'ModernEra-ExtraBold,sans-serif',
  headings: {
    h1: { fontSize: '1.75rem', lineHeight: '2.25rem' },
    h2: { fontSize: '1.5rem', lineHeight: '2rem' },
    h3: { fontSize: '1.375rem', lineHeight: '1.75rem' },
    h4: { fontSize: '1.25rem', lineHeight: '1.625rem' },
    h5: { fontSize: '1.125rem', lineHeight: '1.5rem' },
    h6: { fontSize: '1rem', lineHeight: '1.375rem' },
  },
};
